// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1uQdE","calendarButtons":"ClockData_calendarButtons__3e10u"};